import { useEffect, useRef, useState } from 'react';
import { useGlobalContext } from '~/context/GlobalContext';
import { IChatRoom, IData, IMessage } from '~/types/common';
import { useViewportResize } from '~/hooks/useViewportResize';
import classNames from 'classnames';
import Message from '~/components/MessageContainer/Message';
import styles from './MessageContainer.module.css';
import React from 'react';

function MessageContainer() {
  const { context, setContext } = useGlobalContext();
  const resize = useViewportResize();
  const roomRefs = useRef<Map<string, HTMLDivElement>>(new Map());

  // Scroll do ostatniej wiadomości w aktywnym pokoju
  useEffect(() => {
    const activeRoomRef = roomRefs.current.get(context.room ? context.room.id : '');
    if (activeRoomRef) {
      activeRoomRef.scrollTop = activeRoomRef.scrollHeight;
    }
  }, [context.rooms, context.room, resize.isKeyboardOpen]);

  const renderMessage = (room: any) => {
    if (!room.messages || room.messages.length === 0) {
      return;
    }

    return room.messages.map((msg: IMessage, i: number) => {
      return (
        <React.Fragment key={i.toString()}>
          <Message message={msg} uniqueKey={`${i.toString()}-${msg.serverTime}`} />
        </React.Fragment>);
    });
  };

  return (
    <>
      {context.rooms.length > 0 && context.rooms.map((room: IChatRoom, index: number) => (
        <div
          data-component="MessageContainer"
          key={index.toString()}
          data-room-name={room.name}
          data-room-id={room.id}
          className={classNames(styles.messageContainer, {
            [styles.active]: room.id === (context.room ? context.room.id : false),
          })}
          style={{
            marginTop: resize.isKeyboardOpen
              ? (resize.initialHeight ?? resize.height) - resize.height
              : 0,
          }}
          ref={(el) => {
            if (el) roomRefs.current.set(room.id, el);
          }}
        >
          {/* <div style={{ position: 'fixed', bottom: '40px', background: "black", padding: '5px' }}>Width: {resize.width} Height: {resize.height} IsKeyboardOpen: {resize.isKeyboardOpen ? 'true' : 'false'} </div> */}
          {renderMessage(room)}
        </div>
      ))}
    </>
  );
};

export default MessageContainer;
